import styled from "styled-components"

const QuotationStyled = styled.div`
  max-width: 930px;
  margin: 0 auto;
  padding-bottom: 70px;
  @media (max-width: 880px) {
    padding-bottom: 70px;
  }
  .quotation__item {
    display: flex;
    justify-content: space-between;
    margin-top: -50px;
    &:nth-of-type(even) {
      flex-direction: row-reverse;
    }
    &:nth-of-type(1) {
      margin-top: 0px;
      .quotation__text {
        padding-top: 90px;
        @media (max-width: 880px) {
          padding-top: 0;
        }
      }
    }
    &:nth-of-type(2) {
      .quotation__img {
        margin-top: -190px;
        @media (max-width: 880px) {
          margin-top: 0px;
        }
      }
    }
  }
  .quotation__img {
    @media (max-width: 880px) {
      display: none;
    }
  }
  .quotation__text {
    max-width: 500px;
    width: 100%;
    @media (max-width: 880px) {
      padding-top: 0;
      max-width: 100%;
      padding-left: 40px;
    }
    &__para {
      font-size: 18px;
      position: relative;

      &:before {
        content: "";
        display: block;
        position: absolute;
        top: -10px;
        left: -40px;
        width: 30px;
        height: 30px;
        background: url(${props => props.quoteSign});
        background-repeat: no-repeat;
        background-position: center;
        /* @media (max-width: 880px) {
          left: 0;
        } */
      }
    }
    &__author {
      text-align: right;
      font-size: 18px;
    }
    &__img {
    }
  }
`

export default QuotationStyled
